module.exports = __webpack_public_path__ + "static/media/bannerImg2.b3f46ed5.png";